import { useMemo } from "react";

import { useQuery } from "@apollo/client";

import { type Tos, type TosKey } from "../../gql-generated/types";
import { type GetTosQuery, getTos } from "../api/queries";
import { type ApolloResult } from "../models";

export interface TosResult {
    tos?: Tos;
    acceptedLatestVersion: boolean;
    acceptedOldVersion: boolean;
}

export const useTos = (tosKey: TosKey): ApolloResult<TosResult> => {
    const { data, loading, error } = useQuery<GetTosQuery>(getTos, {
        variables: { key: tosKey },
    });

    return useMemo(() => {
        if (data) {
            const { tos } = data.getTos;
            return {
                loading,
                error,
                tos,
                acceptedLatestVersion:
                    !!tos.acceptedVersion &&
                    tos.acceptedVersion > 0 &&
                    !!tos.metadata?.latestVersion &&
                    tos.acceptedVersion >= tos.metadata.latestVersion,
                acceptedOldVersion:
                    !!tos.acceptedVersion &&
                    tos.acceptedVersion > 0 &&
                    !!tos.metadata?.latestVersion &&
                    tos.acceptedVersion < tos.metadata.latestVersion,
            };
        } else {
            return {
                loading,
                error,
                acceptedLatestVersion: false,
                acceptedOldVersion: false,
            };
        }
    }, [loading, error, data]);
};
